import { CresoTextLogo } from "@core/components/logo/creso-logo";
import { DistributorBranding, DistributorProfile } from "creso-core/types";

export function ReportHeader({
  distributorBranding,
  profile,
}: {
  distributorBranding: DistributorBranding;
  profile: DistributorProfile;
}) {
  const name = distributorBranding?.brand_name || profile?.name;
  return (
    <header className="flex bg-background header fixed top-0 left-0 w-full z-10 p-8 flex-row items-center justify-between">
      <div className="flex flex-row items-center gap-3">
        {distributorBranding?.brand_logo ? (
          <img
            src={distributorBranding?.brand_logo as string}
            alt={distributorBranding?.brand_name}
            className="size-11 rounded-md"
            height={44}
            width={44}
          />
        ) : null}
        {name ? (
          <div className="flex flex-col">
            <span className="text-sm font-semibold">{name}</span>
            <span className="text-sm text-muted-foreground">
              {distributorBranding?.tag_line}
            </span>
          </div>
        ) : null}
      </div>
      <CresoTextLogo height={18} width={80} />
    </header>
  );
}
